<template>
  <div class="result-box">
    <div v-if="resultObj.statusCode == 1" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-pending.png"
        alt=""
      />
      <p class="result-tip">提交成功，等待平台审核</p>
      <p class="result-text">预计1-3个工作日完成,审核结果将通过短信通知您</p>
    </div>
    <div v-if="resultObj.statusCode == 2" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-success.png"
        alt=""
      />
      <p class="result-tip">开通成功</p>
      <p class="result-text">
        已为您开启知识合伙人{{ $route.query.title }}相关权益
      </p>
    </div>
    <div v-if="resultObj.statusCode == 3" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-fail.png"
        alt=""
      />
      <p class="result-tip">审核失败</p>
      <p class="result-text">
        抱歉，您提交的知识合伙人{{
          $route.query.title
        }}相关权益申请未通过平台审核，请依据审核意见修改后再次提交
      </p>
    </div>
    <div v-if="resultObj.statusCode == 4" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-fail.png"
        alt=""
      />
      <p class="result-text">您的{{ $route.query.title }}权益已关闭</p>
    </div>
    <div
      class="content-box"
      v-if="
        !(
          (resultObj.statusCode == 3 && resultObj.reason === '') ||
          resultObj.statusCode == 4
        )
      "
    >
      <p v-if="resultObj.statusCode == 3" class="content-reason">
        {{ resultObj.reason }}
      </p>
      <div v-if="resultObj.statusCode == 1">
        <p class="content-title">您的商户信息：</p>
        <div class="content-text">
          <span>商户编号：</span>
          <span>{{ resultObj.merchantNo }}</span>
        </div>
        <div class="content-text">
          <span>商户名称：</span>
          <span>{{ resultObj.merchantName }}</span>
        </div>
      </div>
      <div v-if="resultObj.statusCode == 2">
        <p class="content-title">您的资金结算信息：</p>
        <div class="content-text">
          <span>开通时间：</span>
          <span>{{ resultObj.auditTime }}</span>
        </div>
        <div class="content-text">
          <span>结算账期：</span>
          <span
            >{{ resultObj.divideAccountNode }}
            {{ resultObj.creditPeriod }}天</span
          >
        </div>
        <div class="content-text flex-content">
          <span class="flex-label">收款商户及比例：</span>
          <div>
            <p>{{ resultObj.payee.merchantName }}</p>
            <p>
              （比例：{{
                resultObj.payee.ratio ? resultObj.payee.ratio : 100
              }}%）
            </p>
          </div>
        </div>
        <div
          class="content-text flex-content"
          v-if="resultObj.accountSplit.length"
        >
          <span class="flex-label">分账商户及比例：</span>
          <div>
            <div
              v-for="(item, index) in resultObj.accountSplit"
              :key="index"
              style="margin-bottom: 5px"
            >
              <div>
                <p>{{ item.merchantName }}</p>
                <p>（比例：{{ item.ratio }}%）</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-text flex-content"
          v-if="resultObj.promotion.merchantName"
        >
          <span class="flex-label">推广商户及比例：</span>
          <span
            >{{ resultObj.promotion.merchantName }}（比例：{{
              resultObj.promotion.ratio
            }}%）</span
          >
        </div>
      </div>
    </div>
    <div class="result-btn">
      <van-button
        v-if="resultObj.statusCode == 3"
        color="#4a79f1"
        round
        type="info"
        @click="toReapply"
        >重新申请</van-button
      >
      <van-button
        v-else
        color="#4a79f1"
        plain
        round
        hairline
        @click="() => this.$router.push({name:'home'})"
        >返回首页</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "EquityResult",
  data() {
    return {
      resultObj: {
        extra: {},
        auditTime: "",
        merchantNo: "",
        merchantName: "",
        divideAccountNode: "",
        statusCode: 0,
        reason: "",
        payee: {},
        accountSplit: [],
        promotion: {},
      },
    };
  },
  created() {
    this.getPartnerDetail();
  },
  methods: {
    async getPartnerDetail() {
      const res = await this.$apis.userServe.getPartnerDetail();
      if (res.resultCode === "200") {
        let businessList = res.content.businessList;
        let bid = this.$route.query.type;
        let resuiltArr = businessList.filter((item) => item.bid === bid);
        this.resultObj = { ...this.resultObj, ...resuiltArr[0] };
      }
    },
    toReapply() {
      this.$router.replace({
        path: "/partner/partner-equity",
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.result-box {
  padding: 0 12px;
  .img-box {
    margin-top: 10vh;
    text-align: center;
    .result-img {
      width: 96px;
      height: 92px;
    }
    .result-tip {
      margin: 8px 0 11px;
      font-size: 15px;
      color: #333333;
    }
    .result-text {
      font-size: 13px;
      color: #999999;
    }
  }
  .content-box {
    margin-top: 25px;
    padding: 15px 17px;
    width: 100%;
    background-color: #f5f5f5;
    border-radius: 8px;
    .content-title {
      font-size: 13px;
      color: #999999;
    }
    .content-reason {
      font-size: 13px;
      color: #333333;
    }
    .content-text {
      margin-top: 12px;
      font-size: 13px;
      color: #333333;
    }
    .flex-content {
      display: flex;
      .flex-label {
        flex: none;
        width: 105px;
      }
    }
  }
  .result-btn {
    margin-top: 30px;
    text-align: center;
    &::v-deep .van-button {
      width: 117px;
    }
  }
}
</style>
